export const button = {
  button: {
    colorScheme: {
      light: {
        text: {
          primary: {
            hoverBackground: '{primary.50}',
            activeBackground: '{primary.100}',
          },
          danger: {
            hoverBackground: '{red.50}',
            activeBackground: '{red.100}',
          },
          secondary: {
            color: 'var(--p-text-color-secondary)',
            hoverBackground: '{surface.100}',
            activeBackground: '{surface.200}',
          },
          plain: {
            hoverBackground: '{slate.100}',
            activeBackground: '{slate.100}',
          },
        },
        primary: {
          hoverBackground: '{primary.400}',
          activeBackground: '{primary.600}',
        },
        outlined: {
          primary: {
            borderColor: 'var(--p-primary-color)',
          },
          danger: {
            borderColor: 'var(--p-danger-color)',
          },
        },
        secondary: {
          background: '{slate.500}',
          activeBackground: '{slate.600}',
          hoverBackground: '{slate.600}',
          borderColor: '{slate.500}',
          activeBorderColor: '{slate.600}',
          hoverBorderColor: '{slate.600}',
          color: 'var(--p-surface-0)',
          activeColor: 'var(--p-surface-0)',
          hoverColor: 'var(--p-surface-0)',
        },
      },
    },
    label: {
      fontWeight: '400',
    },
    paddingY: '0.5rem',
    paddingX: '1rem',
  },
};
